import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Button from '../../../button';
import Avatar from '../../../avatar';
import { API_ROOT, APP_ID, SM_URL, urlParam, authReturnUrl } from '../../../../utils';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import Icon from '../../../icon';
import { getProfile } from '../../../../../actions/profileActions';
import './index.css';

function NewRegisterTemplate() {

	const [currentPage, setCurrentPage] = useState(0);

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const [phoneNumberValue, setPhoneNumberValue] = useState('');
	const [isAdminClaimed, setIsAdminClaimed] = useState(false);
	const [isGmail, setIsGmail] = useState(false);
	const [hasReseller, setHasReseller] = useState(false);
	const [validResellerValue, setValidResellerValue] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const { t } = useTranslation();

	const profile = useSelector(state => state.profileReducer.getProfile);
	const smUser = useSelector(state => state.profileReducer.getSmUser);

	const dispatch = useDispatch();

	const handleResize = () => {
		setDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	useEffect(() => {
		if (profile.email.includes('@gmail.com')) {
			setIsGmail(true)
		}
	}, [profile]);

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}, []);

	const fadeInPicture = () => {
		document.querySelector('.register-picture img').style.visibility = "hidden";
		document.querySelector('.register-picture img').style.opacity = 0;

		setTimeout(() => {
			document.querySelector('.register-picture img').style.visibility = "visible";
			document.querySelector('.register-picture img').style.opacity = 1;
		}, 250);
	};

	const handleKeyPress = useCallback((e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			if (document.querySelectorAll('.register-content__page .next-btn')[currentPage]) {
				document.querySelectorAll('.register-content__page .next-btn')[currentPage].click();
			}
		}
	}, [currentPage]);

	useEffect(() => {
		fadeInPicture();
	}, []);

	useEffect(() => {
		window.addEventListener('keypress', handleKeyPress);

		return () => {
			window.removeEventListener('keypress', handleKeyPress);
		}
	}, [handleKeyPress]);

	const goToPrevPage = (e) => {
		e.preventDefault();

		if (currentPage > 0) {
			setCurrentPage(currentPage - 1);
		}

		if (isAdminClaimed) {
			if (currentPage === 5) {
				fadeInPicture();
			}
		} else {
			if (!isGmail) {
				if (currentPage === 4) {
					fadeInPicture();
				}
			} else {
				if (currentPage === 3) {
					fadeInPicture();
				}
			}
		}
	};

	const goToNextPage = () => {
		if (currentPage < 5) {
			setCurrentPage(currentPage + 1);
		}
	};

	useEffect(() => {

		if (window.innerWidth > 992) {
			document.querySelector('.register').scrollTo(0, 0);
			document.querySelector('.register').style.overflow = "hidden";

			document.querySelector('.register-content').style.top = (currentPage * dimensions.height * -1) + 'px';
		} else {
			document.querySelector('.register').style.overflow = "auto";
			document.querySelector('.register-content').style.top = 0;

			/*
			* On success image height should be set before the scrollTo
			* */

			setTimeout(() => {
				document.querySelector('.register').scrollTo(
					0,
					currentPage
					* document.querySelector('.register-content__page').getBoundingClientRect().height
					+ document.querySelector('.register-picture').getBoundingClientRect().height
				);
			}, 200);
		}

	}, [currentPage, dimensions]);

	const onChangeHandler = (value) => {

		if (value?.length > 3) {

			setPhoneNumberValue(value);

		} else if (value === undefined) {
			setPhoneNumberValue("");
		} else {
			if (document.querySelector('.error-message')) {
				document.querySelector('.error-message').outerHTML = '';
			}
			document.querySelector('.PhoneInputInput').classList.remove('error');
		}
	};

	useEffect(() => {
		if (document.querySelector('.PhoneInputInput').getAttribute('error')) {
			document.querySelector('.PhoneInputInput').classList.add('error');
			let errorMessage = document.createElement('div');
			errorMessage.classList.add('error-message');
			errorMessage.innerHTML = document.querySelector('.PhoneInputInput').getAttribute('error');
			if (!document.querySelector('.error-message')) {
				document.querySelector('.PhoneInputInput').parentNode.appendChild(errorMessage);
			}
		} else {
			if (document.querySelector('.error-message')) {
				document.querySelector('.error-message').outerHTML = '';
			}
			document.querySelector('.PhoneInputInput').classList.remove('error');
			if (phoneNumberValue.length > 3 && !hasReseller) {
				setValidResellerValue(true);
			}
		}
	}, [phoneNumberValue, hasReseller, validResellerValue]);

	const checkResellerVal = () => {
		let resellerVal = document.getElementById('reseller').value.trim();
		let validValue = false;
		if (resellerVal.length === 1) {
			const specialChars = /^[a-zA-Z]+$/;
			validValue = specialChars.test(resellerVal);
			if (!validValue) {
				setValidResellerValue(false);
			} else {
				setValidResellerValue(true);
			}
		} else if (resellerVal.length > 1) {
			setValidResellerValue(true);
		} else {
			setValidResellerValue(false);
		}
	};

	const proceed = () => {

		let payload = null;
		setIsLoading(true);

		if (hasReseller) {
			payload = {
				'contactEmail': profile.email,
				'phoneNumber': phoneNumberValue,
				'resellerName': document.getElementById('reseller').value,
				'landingSite': urlParam('landingSite') ? urlParam('landingSite') : 'GSC APP',
				'name': profile.name,
				'googleId': profile.id,
				'registered': true,
				'installStatus': 'Registered',
				'installType': 'Try',
				'userId': smUser !== null ? smUser[0] : profile.userId,
				'userToken': smUser !== null ? smUser[1] : profile.userToken,
				'isAdmin': (profile.accessStatus && profile.accessStatus.isAdmin),
				'pitch': document.getElementById('pitch').value,
				'role': profile.role,
			}
		} else {
			payload = {
				'contactEmail': profile.email,
				'phoneNumber': phoneNumberValue,
				'landingSite': urlParam('landingSite') ? urlParam('landingSite') : 'GSC APP',
				'name': profile.name,
				'googleId': profile.id,
				'registered': true,
				'installStatus': 'Registered',
				'installType': 'Try',
				'userId': smUser !== null ? smUser[0] : profile.userId,
				'userToken': smUser !== null ? smUser[1] : profile.userToken,
				'isAdmin': (profile.accessStatus && profile.accessStatus.isAdmin),
				'pitch': document.getElementById('pitch').value,
				'role': profile.role,
			}
		}

		axios.put(SM_URL + '/api/products/gsc/users/' + (smUser !== null ? smUser[0] : profile.userId) + '?format=json',
			payload,
			{
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'user-token ' + (smUser !== null ? smUser[1] : profile.userToken)
				}
			}).then(response => {
				if (response.status === 200) {
					if (isAdminClaimed) {
						if (currentPage === 4) {
							fadeInPicture();
						}
					} else {
						if (!isGmail) {
							if (currentPage === 3) {
								fadeInPicture();
							}
						} else {
							if (currentPage === 2) {
								fadeInPicture();
							}
						}
					}

					setCurrentPage(currentPage + 1);
				}
			}).catch((e) => {
				console.error(e);
			}).finally(() => {
				setIsLoading(false);
			});
	};

	const grantContactsAndGoToTheApp = () => {
		window.location.href = API_ROOT + '/account/access-offline?authuser=' + profile.email + '&redirect=' + encodeURIComponent(authReturnUrl(window.location.pathname + window.location.search));
	};

	const grantDomainContactsAndGoToApp = () => {

		setIsLoading(true);

		let winRef = window.open('https://workspace.google.com/marketplace/dwi/' + APP_ID + '?redirect_url=./marketplace/adminoauthpromptredirect&authuser=' + profile.email, '', 'popup=yes', 'width=800,height=600');

		/*
		* Delay to detect the popup is closed
		* */

		let timer = setInterval(function () {
			if (winRef.closed) {

				/*
				* Delay to let the eventual access changes to be applied to the Profile API
				* */

				let profileInterval = setInterval(function () {
					dispatch(getProfile(true));
					clearInterval(profileInterval);
					setIsLoading(false);
				}, 5000);

				clearInterval(timer);

			}
		}, 5000);
	};

	return (
		<div className="register">
			{
				isAdminClaimed
					?
					currentPage > 4
						?
						<div className="register-picture register-picture__success">
							<img src="/img/register-success.png" alt="" />
						</div>
						:
						<div className="register-picture">
							<img src="/img/register.png" alt="" />
							<h2 className="p-5">{t('registerPageTitle')}</h2>
						</div>
					:
					!isGmail
						?
						currentPage > 3
							?
							<div className="register-picture register-picture__success">
								<img src="/img/register-success.png" alt="" />
							</div>

							:
							<div className="register-picture">
								<img src="/img/register.png" alt="" />
								<h2 className="p-5">{t('registerPageTitle')}</h2>
							</div>
						:
						currentPage > 2
							?
							<div className="register-picture register-picture__success">
								<img src="/img/register-success.png" alt="" />
							</div>
							:
							<div className="register-picture">
								<img src="/img/register.png" alt="" />
								<h2 className="p-5">{t('registerPageTitle')}</h2>
							</div>
			}
			<div className="register-content">
				<div className="register-content__page">
					<div className="logged-user">
						<div className="cartridge">
							<Avatar
								size={36}
								className="mr-2"
								src={`${API_ROOT}/account/avatar/${profile.id}`}
								alt={profile.name}
							/>
							<div>
								<p><strong>{profile.name}</strong></p>
								<p>{profile.email}</p>
							</div>
						</div>
						<div>
							<a className="accountchooser" href={`${API_ROOT}/account/logout/?page=register`}>
								{t("changeAccountText")}
							</a>
						</div>
					</div>

					<div>
						<div className="text-center m-5">
							<h2>Hi {profile.name.split(' ')[0]}! 👋</h2>
						</div>

						<h3>{t('registerPageOneTitle')}</h3>
						<p>{t('registerPageOneText')}</p>
						<div className="d-flex align-items-center">
							<Button onClick={goToNextPage} className="btn-primary next-btn">{t('gettingStartedText')}</Button>
							<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
						</div>
					</div>

				</div>
				<div className="register-content__page">
					<h3>{t('registerPageTwoTitle')}</h3>

					<p>{t('registerPageTwoText')}</p>

					<p>{t('registerPageTwoIndication')}</p>

					<PhoneInput
						maxLength={20}
						value={phoneNumberValue}
						onChange={onChangeHandler}
						className={'input-group reg-phn'}
						error={phoneNumberValue ? (isPossiblePhoneNumber(phoneNumberValue) ? undefined : t('validNumber')) : undefined}
					/>

					<div className="d-flex align-items-center">
						<Button disabled={!phoneNumberValue || !isPossiblePhoneNumber(phoneNumberValue)} onClick={goToNextPage} className="btn-primary next-btn">{t('registerPageNextBtn')}</Button>
						<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
					</div>

					<Button onClick={goToPrevPage} className="btn-back ml-auto"><Icon name="angle-up" /></Button>
				</div>
				<div className="register-content__page">
					<h3>{t('registerPageThreeTitle')}</h3>

					<p>{t('registerPageThreeText')}</p>

					<textarea name="pitch" id="pitch" rows="10" />

					<p className="text-right">{t('registerPageOptional')}</p>

					<div className="d-flex align-items-center">
						{
							isLoading
								?
								<Button className="btn-primary" disabled={true}>
									<Icon animated={'pulse'} name="spinner" />
								</Button>
								:
								<>
									<Button onClick={isGmail ? proceed : goToNextPage} className="btn-primary next-btn">{t('registerPageNextBtn')}</Button>
									<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
								</>
						}
					</div>

					<Button onClick={goToPrevPage} className="btn-back ml-auto"><Icon name="angle-up" /></Button>
				</div>
				{
					!isGmail && !(profile.accessStatus && profile.accessStatus.isAdmin) &&
					<div className="register-content__page">
						<h3>{t('registerPageFourTitle')}</h3>

						<div className="answer-choice">
							<Button onClick={() => setIsAdminClaimed(true)} className={`${isAdminClaimed ? 'btn-secondary' : 'btn-outline-secondary'} ml-3`} type="button">{t('yesText')}</Button>
							<Button onClick={() => setIsAdminClaimed(false)} className={`${!isAdminClaimed ? 'btn-secondary' : 'btn-outline-secondary'} ml-3`} type="button">{t('noText')}</Button>
						</div>

						<div className="d-flex align-items-center">
							{
								isLoading
									?
									<Button className="btn-primary" disabled={true}>
										<Icon animated={'pulse'} name="spinner" />
									</Button>
									:
									<>
										<Button onClick={!isAdminClaimed ? proceed : goToNextPage} className="btn-primary next-btn">{t('registerPageNextBtn')}</Button>
										<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
									</>
							}
						</div>
						<Button onClick={goToPrevPage} className="btn-back ml-auto"><Icon name="angle-up" /></Button>
					</div>
				}
				{
					((profile.accessStatus && profile.accessStatus.isAdmin) || isAdminClaimed) && !isGmail &&
					<div className="register-content__page">
						<h3 className="text-center">{t('registerGoogleWorkspaceText')}</h3>

						<div className="answer-choice">
							<Button onClick={() => setHasReseller(true)} className={`${hasReseller ? 'btn-secondary' : 'btn-outline-secondary'} ml-3`} type="button">{t('yesText')}</Button>
							<Button onClick={() => setHasReseller(false)} className={`${!hasReseller ? 'btn-secondary' : 'btn-outline-secondary'} ml-3`} type="button">{t('noText')}</Button>
						</div>

						{
							hasReseller && <div className="form-group">
								<input type="text" id="reseller" className="form-control reseller-field mb-4"
									onChange={checkResellerVal} placeholder={t('resellerNameText')} />
							</div>
						}

						<div className="d-flex align-items-center">
							{
								isLoading
									?
									<Button className="btn-primary" disabled={true}>
										<Icon animated={'pulse'} name="spinner" />
									</Button>
									:
									<>
										<Button onClick={proceed} className="btn-primary next-btn">{t('registerPageNextBtn')}</Button>
										<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
									</>
							}
						</div>

						<Button onClick={goToPrevPage} className="btn-back ml-auto"><Icon name="angle-up" /></Button>
					</div>
				}
				{
					(profile.accessStatus && profile.accessStatus.isAdmin) || isAdminClaimed
						?
						(profile.accessStatus && profile.accessStatus.isDomainApisGranted)
							?
							<div className="register-content__page">
								<div className="text-center">
									<p className="important"><strong>{t('registerPageCongratsOkTitle')}</strong></p>
									<Button onClick={() => window.location.reload()} className="btn-primary next-btn">{t('registerPageShareContactsBtn')}</Button>
									<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
								</div>
							</div>
							:
							<div className="register-content__page">
								<div className="text-left mb-5">
									<p className="important"><strong>{t('registerPageCongratsNearlyDoneTitle')}</strong></p>
									<p>{t('registerPageCongratsAskDomainGrantAccessText')}</p>
									<ul>
										{!(profile.accessStatus && profile.accessStatus.isContactsGranted) && <li>{t('registerPageCongratsContactsGrantedText')}</li>}
										<li>{t('registerPageCongratsDomainApisGrantedText')}</li>
									</ul>
								</div>
								{
									isLoading
										?
										<Button className="btn-primary" disabled={true}>
											<Icon animated={'pulse'} name="spinner" />
										</Button>
										:
										<div className="text-center">
											<Button onClick={grantDomainContactsAndGoToApp} className="btn-primary next-btn">{t('grantAccessPageDomainGrantBtn')}</Button>
											<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
										</div>
								}
							</div>
						:
						(profile.accessStatus && profile.accessStatus.isContactsGranted)
							?
							<div className="register-content__page">
								<div className="text-center">
									<p className="important"><strong>{t('registerPageCongratsOkTitle')}</strong></p>
									<Button onClick={() => window.location.reload()} className="btn-primary next-btn">{t('registerPageShareContactsBtn')}</Button>
									<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
								</div>
							</div>
							:
							<div className="register-content__page">
								<div className="text-center">
									<p className="important"><strong>{t('registerPageCongratsNearlyDoneTitle')}</strong></p>
									<p>{t('registerPageCongratsAskContactsGrantAccessText')}</p>
									<ul>
										<li>{t('registerPageCongratsContactsGrantedText')}</li>
									</ul>
									{
										isLoading
											?
											<Button className="btn-primary" disabled={true}>
												<Icon animated={'pulse'} name="spinner" />
											</Button>
											:
											<>
												<Button onClick={grantContactsAndGoToTheApp} className="btn-primary next-btn">{t('grantAccessPageContactsGrantBtn')}</Button>
												<span className="ml-3">{t('registerPagePressEnterBtn')}</span>
											</>
									}
								</div>
							</div>
				}
			</div>
		</div>
	)
}

export default NewRegisterTemplate;
